import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { IVideoVerificationState } from './VideoVerificationSliceModels'
import { IGenerateSessionResponse } from 'service/VideoVerificationService/VideoVerificationServiceProps'


// TODO - PRZEMYSLEĆ CZY NIE PRZENIEŚĆ DO APPLICATION_SLICE
export const initialVideoVerificationState: IVideoVerificationState = {
   sessionId: '',
   documentId: '',
   videoVerificationUrl: '',
}

export const videoVerificationSlice = createSlice({
   name: SLICE_KEYS.VIDEO_VERIFICATION_SLICE,
   initialState: initialVideoVerificationState,
   reducers: {
      setGenerateSessionParams: (state, action: PayloadAction<IGenerateSessionResponse>) => {
         state.sessionId = action.payload.sessionId
         state.documentId = action.payload.documentId
         state.videoVerificationUrl = action.payload.videoVerificationUrl
      },
   }  
 })
 
 // Action creators are generated for each case reducer function
 export const { setGenerateSessionParams } = videoVerificationSlice.actions
 
 export default videoVerificationSlice.reducer